import { useRoute } from 'vue-router'
import { getFullNameByUser } from '@/services/userService.js'

export const canSetPermissions = () => {
  const route = useRoute()

  return Boolean(
    route?.meta?.permissions &&
    route.meta.permissions.canSetPermissions
  )
}

export const buildPayloadAttributesMassive = (
  modalBulkActionsPayload,
  compiledPoll
) => {

  const rolesMap = {
    default: [
      { key: 'rea', attr: 'gec.involved_subject.rating_evaluation_approver' },
      { key: 're',  attr: 'gec.involved_subject.rating_evaluator' }
    ],
    cmb: [
      { key: 'cc',  attr: 'gec.involved_subject.main_contractor' },
      { key: 'dt',  attr: 'gec.involved_subject.construction_site_manager' }
    ]
  }

  Object.values(rolesMap).forEach(roleSet => {
    const args = roleSet.flatMap(role => {
      const selected = modalBulkActionsPayload[role.key] ? [modalBulkActionsPayload[role.key].reference] : []
      const removed = modalBulkActionsPayload[role.key] ? [compiledPoll.attributes?.[`${role.attr}.delegated`]] : []
      return [selected, removed]
    })

    const currentRoles = roleSet.map(role => compiledPoll.attributes[role.attr])
    compiledPoll = updatePermissions(compiledPoll, ...currentRoles, ...args)
  })

  const payload = {
    userReference: compiledPoll.userReference,
    campaign: compiledPoll.campaign,
    answers: compiledPoll.answers,
    pollTemplateRevisionNumber: compiledPoll.pollTemplateRevisionNumber,
    permissions: compiledPoll.permissions,
    attributes: compiledPoll.attributes
  }

  Object.values(rolesMap).flat().forEach(role => {
    const user = modalBulkActionsPayload[role.key]
    if (!user) return

    const denomination = getFullNameByUser(user)

    const baseAttr = `${role.attr}.delegated`
    payload.attributes[baseAttr] = user.reference
    if (denomination) {
      payload.attributes[`${baseAttr}.denomination`] = denomination
    }
  })

  return payload
}

export const updatePermissions = (
  compiledPoll,
  currentSupervisoreValutazione,
  currentValutatore,
  selected_MainDelegated,
  removed_MainDelegated,
  selected_SecondaryDelegated,
  removed_SecondaryDelegated
) => {
  try {
    let permissions = compiledPoll.permissions

    let places = permissions.places
    places.forEach(place => {
      let placeUserReferences = place['edit']['userReferences']
      updateUserReferences(
        placeUserReferences,
        currentSupervisoreValutazione,
        currentValutatore,
        selected_MainDelegated,
        removed_MainDelegated,
        selected_SecondaryDelegated,
        removed_SecondaryDelegated
      )
    })

    let transitions = permissions.transitions
    transitions.forEach(trans => {
      let transitionUserReferences = trans['can']['userReferences']
      updateUserReferences(
        transitionUserReferences,
        currentSupervisoreValutazione,
        currentValutatore,
        selected_MainDelegated,
        removed_MainDelegated,
        selected_SecondaryDelegated,
        removed_SecondaryDelegated
      )
    })

    compiledPoll.permissions = permissions
    return compiledPoll
  } catch (error) {
      throw error
  }
}

const updateUserReferences = (
  userReferences,
  currentSupervisoreValutazione,
  currentValutatore,
  selected_MainDelegated,
  removed_MainDelegated,
  selected_SecondaryDelegated,
  removed_SecondaryDelegated
) => {
  if (Array.isArray(userReferences)) {
    if (userReferences.includes(currentSupervisoreValutazione)) {
      addUserReferences(userReferences, selected_MainDelegated)
      removeUserReferences(userReferences, removed_MainDelegated, currentSupervisoreValutazione, currentValutatore)
    }

    if (userReferences.includes(currentValutatore)) {
      addUserReferences(userReferences, selected_SecondaryDelegated)
      removeUserReferences(userReferences, removed_SecondaryDelegated, currentSupervisoreValutazione, currentValutatore)
    }
  }
}

const removeUserReferences = (userReferences, removed, currentSupervisoreValutazione, currentValutatore) => {
  userReferences.forEach(ref => {
    if (ref !== currentSupervisoreValutazione && ref !== currentValutatore && removed) {
      const index = userReferences.indexOf(removed[0])
      if (index > -1) {
        userReferences.splice(index, 1)
      }
    }
  })
}

const addUserReferences = (userReferences, selected) => {
  selected.forEach(delegated => {
    if (!userReferences.includes(delegated)) {
      userReferences.push(delegated)
    }
  })
}
